import * as React from 'react';
import { useMemo } from 'react';

import { Typography } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { LoyaltyQuestStatus } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

import { IQuest } from '../loyalty-quest/types';
import { isQuestActivated, isQuestCompleted, isStepCompleted } from '../loyalty-quest/utils';

import { QuestBadgeIcon, QuestBadgeText } from './styled';

interface IQuestBadgeProps {
  quest: IQuest;
}

export const QuestBadge = ({ quest }: IQuestBadgeProps) => {
  const status = quest.status;

  const challengeHasSomeProgress = useMemo(
    () => !!quest?.steps?.some(step => isStepCompleted(step.status)),
    [quest?.steps]
  );

  const isQuestActivedWithProgress = isQuestActivated(status) && challengeHasSomeProgress;

  const text = useMemo(() => {
    if (isQuestCompleted(status)) {
      return t('completed');
    } else if (isQuestActivedWithProgress) {
      // @TODO: I will update this once the translation is generated
      return 'In Progress';
    }

    return t('challengeActivated');
  }, [isQuestActivedWithProgress, status]);

  const textColor =
    status === LoyaltyQuestStatus.COMPLETED ? primitive.$bbqBrown : primitive.$white;
  const iconColor =
    status === LoyaltyQuestStatus.COMPLETED ? primitive.$bbqBrown : primitive.$white;
  const backgroundColor = {
    backgroundColor:
      status === LoyaltyQuestStatus.COMPLETED ? primitive.$successLight : primitive.$bbqBrown,
  };

  return (
    <View style={[styles.container, backgroundColor]}>
      <QuestBadgeIcon fill={iconColor} />
      <Typography variant="copyTwo" color={textColor}>
        {text}
      </Typography>
      <QuestBadgeText variant="copyTwo"></QuestBadgeText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: spacing.$1,
    borderRadius: 3,
    alignItems: 'center',
  },
});
